import React, { Component } from "react"
import { observer } from "mobx-react"
import { Route, Switch } from "react-router-dom"
import ProductList from "./list/ProductList"
import AddProduct from "./add/AddProduct"
import EditProduct from "./edit/EditProduct"

class Products extends Component {
  render() {
    const { match } = this.props
    return (
      <Switch>
        <Route path={`${match.url}/add`} component={AddProduct} />
        <Route path={`${match.url}/:id`} component={EditProduct} />
        <Route path={match.url} component={ProductList} />
      </Switch>
    )
  }
}

Products.displayName = "Products"

export default observer(Products)



// WEBPACK FOOTER //
// ./src/products/Products.js